import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/APM_WHITE_FULL.png';
import colors from '../theme/colors';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Delete Account', path: '/delete-account' },
];

const ApmAppBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // State for mobile menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const go = (path: string) => {
    navigate(path);
    handleClose();
  };

  return (
    <AppBar elevation={0}  position="fixed" sx={{ bgcolor: colors.primary, zIndex: 1201, borderBottom: '1px solid white' }}>
      <Toolbar
        disableGutters
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: { xs: 2, md: '25vw' },
          py: 1,
        }}
      >
        {/* Logo always */}
        <Box
          component="img"
          src={logo}
          alt="APM Logo"
          sx={{
            height: { xs: '60px', md: '100px' },
            width: 'auto',
            objectFit: 'contain',
          }}
        />

        {/* Desktop Nav: horizontal, no wrap, only md+ */}
        <Box
          component="nav"
          sx={{
            ml: 'auto',
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {navLinks.map(({ label, path }) => (
            <Button
              key={path}
              onClick={() => go(path)}
              sx={{
                color: colors.textOnPrimary,
                fontWeight: location.pathname === path ? 700 : 400,
                fontSize: '1rem',
                borderBottom:
                  location.pathname === path ? '2px solid white' : '2px solid transparent',
                borderRadius: 0,
                backgroundColor: 'transparent',
                '&:hover': {
                  borderBottom: '2px solid white',
                  backgroundColor: 'transparent',
                },
              }}
            >
              {label}
            </Button>
          ))}
        </Box>

        {/* Mobile Hamburger: only xs/sm */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleOpen}
          sx={{ ml: 'auto', display: { xs: 'block', md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {navLinks.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => go(path)}>
              {label}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default ApmAppBar;
